module.exports = __webpack_public_path__ + "static/img_4290-ebd5545ee6314695148fe6fd776a1670.webp";